import { configureStore } from '@reduxjs/toolkit';
import appSettingsReducer from '../reducer/reducers/appSettingsReducer';
import notificationsReducer from '../reducer/reducers/notificationsReducer';
import userReducer from '../reducer/reducers/userReducer/userReducer';
import i18nReducer from '../reducer/reducers/i18nReducer';
import chartsReducer from '../reducer/reducers/chartsReducer';
import accountsReducer from '../reducer/reducers/accountsReducer/accountsReducer';
import alertsReducer from '../reducer/reducers/alertsReducer/alertsReducer';
import tableReducer from '../reducer/reducers/tableReducer/tableReducer';
import signalRMiddleware from '../reducer/middleware/alertsMiddleware';
import infoPaneReducer  from '../reducer/reducers/infoPaneReducer';

export default configureStore({
  reducer: {
    appSettings: appSettingsReducer,
    infoPane: infoPaneReducer,
    notifications: notificationsReducer,
    user: userReducer,
    i18n: i18nReducer,
    charts: chartsReducer,
    accounts: accountsReducer,
    alerts: alertsReducer,
    table: tableReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(signalRMiddleware),
});
